import DashboardService from "@/src/api/DashboardService.js";
import CallService from "@/src/api/CallService.js";
import store from "@/src/store/index.js";
import { renderEntity } from "@/src/utils/utils.js";

export const toFetchUsers = async () => {
  try {
    const response = await DashboardService.fetchUsers();
    if (response?.success) {
      return response?.users;
    }
  } catch (error) {
    console.error("An error occurred while fetching users: ", error);
  }
};

export const toFetchUsersWithDeleted = async () => {
  try {
    const response = await DashboardService.fetchUsers("delete");
    if (response?.success) {
      return response?.users;
    }
  } catch (error) {
    console.error(
      "An error occurred while fetching users with deleted: ",
      error,
    );
  }
};

export const userDetailsFromID = async (id) => {
  try {
    return store.getters["users/users"]?.find((user) => user.id === id);
  } catch (error) {
    console.error(
      "An error occurred while getting user details from ID: ",
      error,
    );
  }
};

export const toFetchTeams = async () => {
  try {
    const response = await DashboardService.fetchTeams();
    if (response?.success) {
      return response?.teams;
    }
  } catch (error) {
    console.error("An error occurred while fetching teams: ", error);
  }
};

export const getUserNameByID = (id) => {
  try {
    const numId = typeof id === "string" ? parseInt(id, 10) : id;
    if (!isNaN(numId)) {
      const user = store.getters["users/users"]?.find((u) => u.id === numId);
      if (user) {
        return renderEntity(user);
      }
    }
    return id;
  } catch (error) {
    console.error("An error occurred while getting user name by ID: ", error);
  }
};

export const getUserDetailsByIdSync = (userId) => {
  try {
    if (userId === null || userId === undefined) return null;

    const usersWithDeleted = store.getters["users/usersWithDeleted"] || [];
    const user = usersWithDeleted.find(
      (u) => u.id === parseInt(userId) || u.id === userId,
    );

    if (user) return user;
    return { name: getUserNameByIdSync(userId), email: "" };
  } catch (error) {
    console.error(
      "An error occurred while getting user details by ID sync: ",
      error,
    );
    return null;
  }
};

export const getUserNameByIdSync = (userId) => {
  try {
    const allUsers = store.getters["users/allUsers"];

    if (userId === null || userId === undefined) return "";

    const user = allUsers.find(
      (u) => u.id === parseInt(userId) || u.id === userId,
    );

    return user?.name || user?.full_name || user?.email || `User ${userId}`;
  } catch (error) {
    console.error(
      "An error occurred while getting username by ID sync: ",
      error,
    );
  }
};

export const getUserInfoByIdSync = (userId) => {
  try {
    if (userId === null || userId === undefined)
      return { name: "", isDeleted: false };
    if (userId === 0 || userId === "0")
      return { name: "SuperAGI", isDeleted: false };

    const usersWithDeleted = store.getters["users/usersWithDeleted"] || [];
    const user = usersWithDeleted.find(
      (u) => u.id === parseInt(userId) || u.id === userId,
    );
    if (user) {
      return {
        name: user?.name || user?.full_name || user?.email || `User ${userId}`,
        isDeleted: user?.isDeleted || false,
      };
    }

    return { name: `User ${userId}`, isDeleted: true };
  } catch (error) {
    console.error(
      "An error occurred while getting user info by ID sync: ",
      error,
    );
    return { name: "", isDeleted: false };
  }
};
